module.exports = __webpack_public_path__ + "static/media/北京假日阳光别墅供暖升级项目.1caaa301.jpg";